import { Injectable } from '@angular/core';
import { Configuration, ReferenceService } from '../../api-client';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Country } from '../../models/reference/country';
import { State } from '../../models/reference/state';
import { TournamentScoringType } from '../../models';

@Injectable({
  providedIn: 'root',
})
export class RefService extends ReferenceService {
  constructor(httpClient: HttpClient, config: Configuration) {
    super(httpClient, config.basePath!, config);
  }

  /**
   * Get countries from API
   */
  getCountries(): Observable<Country[]> {
    return super.getCountriesEndpoint();
  }

  /**
   * Get states from API
   */
  getStates(): Observable<State[]> {
    return super.getStatesEndpoint();
  }
}
